import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './mobile-sidebar.styles'
import classNames from 'classnames'
import SidebarItem from './sidebar-item/sidebar-item.container'
import BarsIcon from 'react-icons/lib/fa/bars'
import InfoIcon from 'react-icons/lib/fa/info-circle'
import CopyIcon from 'react-icons/lib/fa/copy'
import CloseIcon from 'react-icons/lib/fa/times-circle'

class MobileSidebar extends Component {
  state = { pendingCopy: false }
  processCopy(onCopy) {
    this.setState({ pendingCopy: true })
    onCopy()
  }
  render() {
    const {
      classes,
      className,
      opened,
      infoOpened,
      noNotes,
      onBurgerClick,
      onInfoClick,
      onCloseClick,
      onCopy
    } = this.props
    const { pendingCopy } = this.state
    return (
      <div
        className={classNames(
          classes.container,
          { [classes.opened]: opened },
          className
        )}>
        <SidebarItem
          onClick={onBurgerClick}
          active={opened}
          icon={<BarsIcon />}
        />
        <SidebarItem
          onClick={onInfoClick}
          disabled={noNotes}
          active={infoOpened}
          icon={<InfoIcon />}>
          Teaching notes
        </SidebarItem>
        <SidebarItem
          disabled={pendingCopy}
          onClick={() => this.processCopy(onCopy)}
          icon={<CopyIcon />}>
          Create my copy
        </SidebarItem>
        <SidebarItem onClick={onCloseClick} icon={<CloseIcon />}>
          Close preview
        </SidebarItem>
      </div>
    )
  }
}

export default injectSheet(styles)(MobileSidebar)
